module.exports = __webpack_public_path__ + "img/S2F4_new.64b5c375.jpg";